import React, {useContext, useRef, useState, useEffect} from 'react';
import {Container} from "react-bootstrap";
import PageHeader from "components/PageHeader";
import AgGridToolbar from "components/AgGridToolbar/AgGridToolbar";
import {AgGridReact} from "ag-grid-react";
import {
    DEFAULT_GRID_PAGINATION_SIZE,
    ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE,
    GRID_COLUMN_PROPERTY
} from "utils/Constants";
import {
    dateToString, formatDateToyyyyMMDD,
    stringToDate
} from "utils/FormatUtils";
import useWindowDimensions from "hooks/Dimensions";
import {MnyWiresContext} from "./context";
import {createExcelExportParams} from "utils/ExcelExportUtils";
import {UtilsContext} from "../../../context/utils";
import {ActionPanelContext} from "context/action";
import * as URL from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import {EntityAccountsContext} from "components/entity-accounts/context";
import {addPropertiesToGridColumns, getDisplayedNumberOfGridRows} from "../../../utils/gridColumnUtils";
import ScrollButton from "../../../components/AgGridToolbar/ToolBarButtons/ScrollButton";

export default function MnyWiresResultPanel() {

    const {mnyWiresResultsDisplayState, setMnyWiresResultsDisplayState,
        showGridToolbar, setShowGridToolbar, mnyWiresPanelFilterState} = useContext(MnyWiresContext)
    const {hiddenExportGridApi, showButton, setShowButton, paginationPageSize, setPaginationPageSize} = useContext(UtilsContext);
    const {makeGetRequestNoParams, makePutRequest, makePostRequest} = useContext(SecurityContext);
    const {error} = useContext(ToastContext);
    const {setHandleApproveFunction, setHandleRejectFunction,
        setHandleExportFunction, setHandleRefreshFunction,
        setIsValidApprover, isValidApprover,
        setIsValidRejecter, isValidRejecter
    } = useContext(ActionPanelContext)
    const {entityAccountsNoSwap} = useContext(EntityAccountsContext);

    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [columnDefs, setColumnDefs] = useState([]);

    const {isMobile} = useWindowDimensions();

    const columnTypes ={
        flexColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            suppressMenu:true,
            flex:1,
            suppressMovable:true,
        },
        FlexHeightColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            lockPinned:!!isMobile,
            autoHeight: true,
            wrapText: true,
            minWidth:300

        }
    }

    const defaultColDef = {
        sortable:true,
        resizable:true,
        floatingFilter:true,
        filter:true,
        enableCellChangeFlash:true,
        lockPinned:!!isMobile,
    };

    useEffect(() => {
        if(mnyWiresResultsDisplayState.resData && mnyWiresResultsDisplayState.resData.length > 0)
            setRowData(mnyWiresResultsDisplayState.resData)
        else
            getMnyWires()
       // setColumnDefs(setupActionColumns());

    }, [])

    const getMnyWires = () => {
        const params = {
            accountId:"",
            managerId:-1,
            status:"ALL",
            dtStart:formatDateToyyyyMMDD(),
            dtEnd:formatDateToyyyyMMDD()
        }

        const onSuccessResponse = (response) => {
            setShowGridToolbar(response.data.length >= 0)

            const mnyWiresDisplayState = JSON.parse(JSON.stringify(mnyWiresResultsDisplayState))
            mnyWiresDisplayState.resData = ([...response.data])
            setMnyWiresResultsDisplayState(mnyWiresDisplayState);
        }
        const onErrorResponse = (err) => {
            console.error(err);
            error("Error getting money wires data")
        }

        makePostRequest(params,
            URL.MNY_WIRE_SEARCH_URL , onSuccessResponse, onErrorResponse);
    };

    useEffect(() => {
        setRowData(mnyWiresResultsDisplayState.resData);
        setHandleExportFunction({handleExport:exportQueryList, gridApi: gridApi});
        setHandleApproveFunction({handleApprove:handleApproveActionClicked, gridApi: gridApi})
        setHandleRejectFunction({handleReject:handleRejectActionClicked, gridApi: gridApi})
        setHandleRefreshFunction({handleRefresh: handleRefreshActionClicked, gridApi:null });
    }, [mnyWiresResultsDisplayState])


    const handleApproveActionClicked = (comment, data, onSuccess, onError, approvalReference ) => {

        const params = []

        data.forEach(data => {
            params.push({
                "id": data.id,
                "idWire": data.idWire,
                "comment": comment,
                "fedIntlWireRefNum": approvalReference,
            })
        })

        const onSuccessResponse = (response) => {
            if(onSuccess) onSuccess()
            handleRefresh()
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if(onError) onError(err);
        }

        makePutRequest(params, URL.MNY_WIRE_APPR_URL , onSuccessResponse, onErrorResponse);
    }

    const handleRejectActionClicked = (comment, data, onSuccess, onError ) => {

        const params = []

        data.forEach(data => {
            params.push({"id": data.id, "idWire": data.idWire, "comment": comment})
        })

        const onSuccessResponse = (response) => {
            if(onSuccess) onSuccess()
            handleRefresh()
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if(onError) onError(err);
        }

        makePutRequest(params, URL.MNY_WIRE_REJ_URL , onSuccessResponse, onErrorResponse);
    }

    const exportQueryList = (type, rowData) => {
        const columnDef = columnDefsResultsPanel.filter(col => col.headerName !== 'Select')

        //Set Column definition
        hiddenExportGridApi.current.api.setColumnDefs(columnDef);
        //Set Data
        hiddenExportGridApi.current.api.setRowData(rowData || mnyWiresResultsDisplayState.resData);
        //Export as csv/excel
        type==='EXCEL' ?
            hiddenExportGridApi.current.api.exportDataAsExcel(createExcelExportParams('Wires')) :
            hiddenExportGridApi.current.api.exportDataAsCsv()
    }

    const handleRefreshActionClicked = (refreshCriteria ,gridApi , onSuccess, onError) => {
        handleRefresh(refreshCriteria)

    };

    const handleRefresh = (refreshCriteria) => {

        const params = {
            accountId: entityAccountsNoSwap.accountId,
            managerId: entityAccountsNoSwap.managerId,
            status:mnyWiresPanelFilterState.status,
            dtStart: mnyWiresPanelFilterState.startDate ? dateToString(mnyWiresPanelFilterState.startDate) : null,
            dtEnd: mnyWiresPanelFilterState.endDate ? dateToString(mnyWiresPanelFilterState.endDate) : null,
        }

        const onSuccessResponse = (response) => {
            setShowGridToolbar(response.data.length >= 0)

            const mnyWiresDisplayState = JSON.parse(JSON.stringify(mnyWiresResultsDisplayState))
            mnyWiresDisplayState.resData = ([...response.data])
            mnyWiresDisplayState.wireSearch = params
            setMnyWiresResultsDisplayState(mnyWiresDisplayState);
        }
        const onErrorResponse = (err) => {
            console.error(err);
            error("Error refreshing money wires data")
        }

        makePostRequest(params,
            URL.MNY_WIRE_SEARCH_URL , onSuccessResponse, onErrorResponse);
    }

    const LogItem = function (params){
        return(<>
            {
                params.value.toString().split("\r\n").map( (log, index) => {
                    return (<React.Fragment key={`log-line-${index}`}>{log}<br /></React.Fragment>)
                })}
        </>);
    }

    const logRenderer = function (props){
        if(!props.data.comments)
            return (<></>)
        return <LogItem value = {props.data.comments}/>
    }
    const logRendererCustodianMessage = function (props){
        if(!props.data.custodianMessage)
            return (<></>)
        return <LogItem value = {props.data.custodianMessage}/>
    }
    const instructionsRenderer = function (props){
        if(!props.data.wireInstructions)
            return (<></>)
        return <LogItem value ={props.data.wireInstructions}/>
    }

    const instructionsRendererWireRefNum = function (props){
        if(!props.data.wireRefNum)
            return (<></>)
        return <LogItem value ={props.data.wireRefNum}/>
        }


    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }

    const onDataRendered = (params) => {
        params.columnApi.autoSizeAllColumns();
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    const onPaginationChanged = () => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    function pageTitle(){
        return "Money Wires "
    }

    const onRowSelected = (row) => {

        if(!row.node.selected || row.data.isApproveEnabled !== isValidApprover) {
            setIsValidApprover(true)

            gridApi.getSelectedRows()
                .filter(row => !row.isApproveEnabled)
                .map(row => {
                        setIsValidApprover(row.isApproveEnabled);
                    }
                );
        }

        if(!row.node.selected || row.data.isRejectEnabled !== isValidRejecter){
            setIsValidRejecter(true)

            gridApi.getSelectedRows()
                .filter(row => !row.isRejectEnabled)
                .map(row => {
                        setIsValidRejecter(row.isRejectEnabled);
                    }
                );
        }

    }

    const isRowSelectable = rowNode => rowNode.data ? (rowNode.data.status.includes('CAPPR') || rowNode.data.status.includes('TDAPPR'))&& rowNode.data.isOldMappedAccount === 0: false;

    const updatedColumnDefs = addPropertiesToGridColumns(columnDefsResultsPanel, GRID_COLUMN_PROPERTY)

    return(<>
        <Container fluid>
            <PageHeader text={pageTitle()}>
                {/*<WiresParamsBadge/>*/}
            </PageHeader>

            { showGridToolbar && <AgGridToolbar
                            mnyWiresScreen={true}
                            gridApi={gridApi}
                            gridColumnApi={gridColumnApi}
                            columnDefs={columnDefs}
                            setColumnDefs={setColumnDefs}
                            refreshCriteria={mnyWiresResultsDisplayState.wireSearch}
                            rowData={rowData}
                            paginationPageSize={paginationPageSize}
                            setPaginationPageSize={setPaginationPageSize}
            >
            </AgGridToolbar>}
            <div className="ag-theme-alpine">
                <AgGridReact
                    ref={gridRef}
                    domLayout={'autoHeight'}
                    frameworkComponents={{
                        logRenderer: logRenderer,
                        logRendererCustodianMessage: logRendererCustodianMessage,
                        instructionsRenderer: instructionsRenderer,
                        instructionsRendererWireRefNum: instructionsRendererWireRefNum,
                    }}
                    paginationPageSize={DEFAULT_GRID_PAGINATION_SIZE}
                    groupDefaultExpanded={'1'}
                    enableRowGroup={false}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    suppressModelUpdateAfterUpdateTransaction={true}
                    suppressScrollOnNewData={true}
                    suppressAggFuncInHeader={true}
                    allowShowChangeAfterFilter={false}
                    rowGroupPanelShow={'never'}
                    enableSorting={true}
                    enableFilter={true}
                    pagination={true}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onDataRendered}
                    onPaginationChanged={onPaginationChanged}
                    rowDataUpdated={onDataRendered}
                    defaultColDef={defaultColDef}
                    columnDefs={updatedColumnDefs}
                    columnTypes={columnTypes}
                    rowData={rowData}
                    animateRows={true}
                    rowSelection={'multiple'}
                    onRowSelected={onRowSelected}
                    isRowSelectable={isRowSelectable}
                    popupParent={document.body}
                >
                </AgGridReact>
            </div>
        </Container>
        {showButton && <ScrollButton showButton={showButton}/>}
    </>);
}

export const columnDefsResultsPanel = [
    {headerName: 'Select', checkboxSelection:true,suppressMovable:true, lockPosition:true, filter:false, maxWidth :100},
    {headerName: 'id', field: 'id',hide:true, colId: 'id', suppressColumnsToolPanel:true},
    {headerName: 'idWire', field: 'idWire',hide:true, colId: 'idWire', suppressColumnsToolPanel:true},
    {headerName: 'Status', field: 'status'},
    {headerName: 'Effective', field: 'dtEffective', valueGetter: (params)=>stringToDate(dateToString(params.data.dtEffective))},
    {headerName: 'Client', field: 'cdClient'},
    {headerName: '3rd Party', field: 'thirdParty'},
    {headerName: 'Funds Out', field: 'mnyOut'},
    {headerName: 'CcyOut', field: 'ccyOut'},
    {headerName: 'Reason', field: 'reason'},
    {headerName: 'WireInst', field: 'wireInstructions', type: 'FlexHeightColType',cellRenderer: 'instructionsRenderer'},
    {headerName: 'Comments', field: 'comments', type: 'FlexHeightColType',cellRenderer: 'logRenderer'},
    {headerName: 'WireRefNum', field: 'wireRefNum', type: 'FlexHeightColType', cellRenderer: 'instructionsRendererWireRefNum'},
    {headerName: 'SenderBic',field:'senderBic'},
    {headerName: 'RspSent',field:'rspSent'},
    {headerName: 'UniqRspId',field:'uniqRspId'},
    {headerName: 'IndDirection',field:'indDirection'},
    {headerName: 'Custodian Message', field: 'custodianMessage',wrapText :true,autoHeight:true,resizable:true, cellRenderer: 'logRendererCustodianMessage'},
    {headerName: '', field: '', type: 'flexColType', suppressColumnsToolPanel: true},
];
